<template>
	<header class="ProfileHeader">
		<div class="ProfileHeader__title">
			<h1 class="h6 font-weight-normal">{{ $t('profile.titleText') }}</h1>
			<h2 class="h3 font-weight-normal">{{ subTitle }}</h2>
		</div>
	</header>
</template>

<script>
export default {
	name: 'ProfileHeader',
	components: {},
	props: {
		subTitle: {
			type: String,
			default: ''
		}
	},
	methods: {},
	created() {}
}
</script>

<style scoped lang="scss">
.ProfileHeader {
	display: flex;
	align-items: center;
	padding-bottom: 20px;

	&__title {
		h1 {
			color: $colorGrey7;
			font-weight: normal;
		}
		h2 {
			color: $colorPrimary;
		}
	}

	&__icon {
		width: 100px;
		height: 100%;
		svg {
			fill: $colorPrimary;
		}
	}
}
</style>
